export const isMobileDevice = () =>
  (typeof window !== "undefined" &&
    typeof window.orientation !== "undefined") ||
  (typeof navigator !== "undefined" &&
    navigator.userAgent.indexOf("IEMobile") !== -1);

export const isTabletDevice = () =>
  isMobileDevice() && window && window.innerWidth >= 500;

export const isPhoneDevice = () => isMobileDevice() && !isTabletDevice();

// solution found here: https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export const isIOSDevice =
  [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes("Mac") && "ontouchend" in document);
